import { Component } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { lastValueFrom } from "rxjs";
import { FormManager } from "./services/forms/form-manager";
import { AuthenticationService } from "./services/swagger";
import { UserDataService } from "./services/user/user.service";
import { SideMenuService } from "./shared/side-menu/side-menu.service";
import { ROUTES } from "./utils/routes";

@Component({
  selector: "auth-code-mobile",
  template: "",
})
export class AuthCodeMobileComponent {
  constructor(
    private formManager: FormManager,
    private fb: FormBuilder,
    private userService: UserDataService,
    private sideMenuService: SideMenuService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  async ngOnInit() {}

  async ionViewWillEnter() {
    let queryParams: any = this.route.snapshot.queryParams;
    if (
      queryParams &&
      queryParams.code &&
      queryParams.session_state &&
      queryParams.state
    ) {
      let submitFn = async () => {
        let result;
        let res = this.authenticationService.apiAuthenticationCallBackPost({
          aDIdentityModel: {
            isApp: true,
            ...queryParams,
          },
        });
        result = await lastValueFrom(res);
        await this.userService.login(result);
        if (
          (result && !result.tenantProfiles) ||
          (result &&
            result.tenantProfiles &&
            result.tenantProfiles.length === 0)
        ) {
          const settings = await this.userService.getCurrentUserSettings();
          if (settings && settings.length) {
            const defaultPageSetting = settings.find(
              (s) => s.userSettingName === "DefaultPage",
            );

            if (defaultPageSetting) {
              if (defaultPageSetting.userSettingValue) {
                if (defaultPageSetting.userSettingValue === "quickSearch") {
                  this.router.navigateByUrl(ROUTES.QUICK_SEARCH_PAGE);
                } else {
                  this.router.navigateByUrl(
                    defaultPageSetting.userSettingValue,
                  );
                }
              } else {
                this.router.navigateByUrl(ROUTES.HELP_PAGE);
              }
            } else {
              this.router.navigateByUrl(ROUTES.HELP_PAGE);
            }

            const hideSideMenuSetting = settings.find(
              (s) => s.userSettingName === "HideSideMenu",
            );

            if (hideSideMenuSetting?.userSettingValue === "Yes") {
              this.sideMenuService.toggleSidebar();
            }
          } else {
            this.router.navigateByUrl(ROUTES.HELP_PAGE);
          }
        } else if (
          result &&
          result.tenantProfiles &&
          result.tenantProfiles.length
        ) {
          this.router.navigateByUrl(ROUTES.MULTITENANT_ACCESS_PAGE);
        } else if (result && result.error) {
          this.router.navigateByUrl(ROUTES.LOGIN_PAGE);
        }
      };
      await this.formManager.submit(this.fb.group({}), submitFn);
    } else {
      await this.userService.logout();
    }
  }
}
